import React, { FC } from 'react';
import { MicroFrontend, SpecificMicroFrontendProps } from '../../core';
import { constants } from './constants';

export interface LoginMicroFrontendProps extends SpecificMicroFrontendProps {
  onLoginSuccessful?: (permissions: any) => void;
}

export const LoginMicroFrontend: FC<LoginMicroFrontendProps> = ({
  entryPointUrl,
  onLoginSuccessful,
  ...props
}) => {
  return (
    <MicroFrontend
      entryPointUrl={entryPointUrl}
      name={constants.MFE_LOGIN_NAME}
      exposedPath={constants.MFE_EXPOSED_PATH}
      params={{ onLoginSuccessful }}
      {...props}
    />
  );
};
